(() => {
  // src/js/iwishlist-observer.js
  if (!window.iwishObserver) {
    window.iwishObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            const iwishAddChildren = node.querySelectorAll && node.querySelectorAll(".iWishAdd");
            if (iwishAddChildren && iwishAddChildren.length) {
              iwishAddChildren.forEach((child) => {
                if (child.innerHTML == "") {
                  child.innerHTML = window.iWishData.iwish_add_txt;
                }
                iWish.iwishAddClick(child);
                let vId = child.getAttribute("data-variant");
                if (vId && iWish.isInWishlist(vId)) {
                  iWish.setIwishAdded(child);
                } else {
                  iWish.setIwishRemoved(child);
                }
              });
            }
          }
        });
      });
    });
    const relatedProductsSection = document.querySelector(".shopify-section--related-products");
    if (relatedProductsSection) {
      window.iwishObserver.observe(relatedProductsSection, { childList: true, subtree: true });
    }
  }
})();
